<!--
  @description 版本发布录入
  @author xiehan
  @date 2018/12/17
-->
<template>
  <div class="releaseVersion__content">
    <el-form ref="searchForm" :model="searchForm" :inline="true">
      <el-form-item :label="$t('common.time')" input-width="auto">
        <el-form-item prop="startTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.startTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <span v-text="$t('common.to')"></span>
        <el-form-item prop="endTime" style="margin-left: 10px">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.endTime" type="datetime">
          </el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item :label="$t('releaseVersion.type')" input-width="auto">
        <g-select v-model="searchForm.type" :list="select_type" :defaultAll="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('releaseVersion.group')" input-width="auto">
        <g-select v-model="searchForm.group" :list="select_group" :defaultAll="true"></g-select>
      </el-form-item>
      <el-form-item input-width="auto">
        <el-button type="primary" 
          v-g-rac="gRac('releaseVersion_search')"
          @click="search"
          v-text="$t('common.search')"></el-button>
        <el-button type="primary"
          v-g-rac="gRac('releaseVersion_add')"
          @click="addRelease"
          v-text="$t('common.add')"></el-button>
        <el-button type="primary" 
          v-g-rac="gRac('releaseVersion_export')"
          @click="e_export" 
          v-text="$t('releaseVersion.export')">
        </el-button>
      </el-form-item>
    </el-form>
    <el-table-extend
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
    border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <el-dialog :closeOnClickModal="false"
      :title="releaseDiaTitle"
      :visible.sync="releaseDiaVis"
      width="400px">
      <el-form ref="handleForm" :model="handleForm" input-width="180px" label-width="100px" :rules="rules">
        <el-form-item :label="$t('releaseVersion.releaseTime')" prop="releaseTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="handleForm.releaseTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('releaseVersion.group')" prop="group">
          <g-select v-model="handleForm.group" :list="select_group"></g-select>
        </el-form-item>
        <el-form-item :label="$t('releaseVersion.type')" prop="type">
          <g-select v-model="handleForm.type" :list="select_type"></g-select>
        </el-form-item>
        <el-form-item :label="$t('releaseVersion.version')" prop="version">
          <el-input v-model="handleForm.version"></el-input>
        </el-form-item>
        <el-form-item :label="$t('releaseVersion.charity')" prop="charity">
          <el-input v-model="handleForm.charity"></el-input>
        </el-form-item>
        <el-form-item :label="$t('releaseVersion.relaseStatus')" prop="relaseStatus">
          <g-select v-model="handleForm.relaseStatus" :list="select_release"></g-select>
        </el-form-item>
        <el-form-item :label="$t('releaseVersion.remainProblem')" prop="remainProblem" input-width="auto">
          <el-input v-model="handleForm.remainProblem" type="textarea" :rows="2"></el-input>
        </el-form-item>
        <el-form-item :label="$t('releaseVersion.note')" prop="note" input-width="auto">
          <el-input v-model="handleForm.note" type="textarea" :rows="2"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="releaseDiaVis = false" v-text="$t('common.cancel')"></el-button>
        <el-button type="primary" @click="saveDic" v-text="$t('common.confirm')"></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import systemSettingBiz from '@/logic/systemSetting/systemSettingBiz'
  import exportTips from '@/components/mixins/exportTips'
  import { extend } from '@/utils/tool'
  import TimeFormat from '@/utils/timeFormat'
  const DIC_MAP = {
    type: 'versionType',
    group: 'groupType'
  }

  export default {
    mixins: [rac, table, dic, exportTips],
    data () {
      return {
        searchForm: {
          startTime: new Date(new Date().toLocaleDateString()).getTime(),
          endTime: '',
          type: '',
          group: ''
        },
        select_type: {},
        select_group: {},
        select_release: {},
        tableControl: [
          {
            label: this.$t('common.delete'),
            callback: (row, index, data) => {
              this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: 'warning'
              }).then(() => {
                systemSettingBiz.deleteRelease({ id: row.id }).then(() => {
                  this.successMessage()
                  this.searchTable()
                })
              }).catch(() => {})
            },
            rac: () => this.gRac('releaseVersion_delete')
          }, {
            label: this.$t('common.edit'),
            callback: (row, index, data) => {
              this.editDic(row)
            },
            rac: () => this.gRac('releaseVersion_amend')
          }
        ],
        releaseDiaTitle: '',
        releaseDiaVis: false,
        rules: {
          releaseTime: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('releaseVersion.releaseTime')}` }
          ],
          version: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('releaseVersion.version')}` }
          ],
          charity: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('releaseVersion.charity')}` }
          ],
          remainProblem: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('releaseVersion.remainProblem')}` }
          ]
        },
        handleForm: {
          type: '',
          group: '',
          version: '',
          releaseTime: '',
          charity: '',
          note: '',
          relaseStatus: '',
          remainProblem: ''
        },
        selectId: '',
        doExport: null
      }
    },
    methods: {
      async preInitTable () {
        await Promise.all([
          this.dGetDictionaryByCode('versionType'),
          this.dGetDictionaryByCode('groupType'),
          this.dGetDictionaryByCode('relaseStatus')
        ])
        this.select_type = { ...this.dDictionary.versionType }
        this.select_group = { ...this.dDictionary.groupType }
        this.select_release = { ...this.dDictionary.relaseStatus }
        this.initTable()
      },
      initTable () {
        this.tInitTable({
          lanKey: 'releaseVersion.table',
          head: ['version', 'type', 'group', 'releaseTime', 'createTime', 'creater', 'charity', 'note'],
          requestFun: this.searchTable,
          headOpt: {
            type: {
              formatter: 'Dictionary',
              formatterDic: this.select_type
            },
            group: {
              formatter: 'Dictionary',
              formatterDic: this.select_group
            }
          }
        })
      },
      search () {
        this.tResetPage()
        this.searchTable()
      },
      searchTable () {
        const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
        if (!reqData.endTime) reqData.endTime = new Date().getTime()
        systemSettingBiz.getRelease(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map(item => {
              item.createTime = TimeFormat.getFormatTime(item.createTime)
              item.releaseTime = TimeFormat.getFormatTime(item.releaseTime)
            })
          }
          this.tData = data
        })
      },
      addRelease () {
        this.releaseDiaTitle = this.$t('common.add')
        this.releaseDiaVis = true
        this.handleForm = {
          type: Object.keys(this.select_type)[0],
          group: Object.keys(this.select_group)[0],
          version: '',
          releaseTime: '',
          charity: '',
          note: '',
          relaseStatus: Object.keys(this.select_release)[0],
          remainProblem: ''
        }
        this.$nextTick(() => {
          this.$refs.handleForm.clearValidate()
        })
      },
      editDic (row) {
        this.releaseDiaTitle = this.$t('common.edit')
        this.releaseDiaVis = true
        this.handleForm = {
          type: this.translateDic(row.type, this.select_type),
          group: this.translateDic(row.group, this.select_group),
          version: row.version,
          releaseTime: TimeFormat.formatTimeTolong(row.releaseTime),
          charity: row.charity,
          note: row.note,
          relaseStatus: row.relaseStatus,
          remainProblem: row.remainProblem
        }
        this.selectId = row.id
      },
      translateDic (value, dic) {
        return Object.keys(dic).filter(item => dic[item] === value)[0]
      },
      saveDic () {
        this.$refs['handleForm'].validate((valid) => {
          if (valid) {
            let eventName = this.releaseDiaTitle === this.$t('common.edit')
              ? 'changeRelease' : 'addRelease'
            let saveObj = { ...this.handleForm }
            if (this.releaseDiaTitle === this.$t('common.edit')) saveObj.id = this.selectId
            systemSettingBiz[eventName](saveObj).then(data => {
              this.releaseDiaVis = false
              this.successMessage()
              this.searchTable()
            })
          } else {
            return false
          }
        })
      },
      successMessage () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
      },
      e_export () {
        const search = extend({}, this.searchForm)
        if (!this.doExport) this.doExport = this.exportTable()
        this.doExport(search)
      },
      exportTable () {
        const that = this
        const list = Object.assign({}, that.$t('releaseVersion.table'))
        const dictionary = []
        for (const key in DIC_MAP) {
          dictionary.push({
            relate: key,
            type: that.dDictionary[DIC_MAP[key]]
          })
        }
        return function (search) {
          that.exRenderBefore()
          systemSettingBiz.exportVersion(
            list,
            search,
            ['createTime', 'releaseTime'],
            dictionary,
            that.exRenderTips,
            that.exRenderFail
          )
        }
      }
    },
    mounted () {
      this.preInitTable()
      this.searchTable()
    }
  }
</script>

<style scoped>

</style>